import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import { AuthProvider } from '@/context/AuthContext'
import Layout from '@/components/Layout'
import ProtectedRoute from '@/components/ProtectedRoute'
import BuildPage from '@/pages/BuildPage'
import ToastPage from '@/pages/ToastPage'
import WarmupsPage from '@/pages/WarmupsPage'
import WarmupDetailPage from '@/pages/WarmupDetailPage'
import ApproachPage from '@/pages/ApproachPage'
import LoginPage from '@/pages/LoginPage'
import SignupPage from '@/pages/SignupPage'
import StudioListPage from '@/pages/studio/StudioListPage'
import WarmupEditorPage from '@/pages/studio/WarmupEditorPage'
import TagsPage from '@/pages/studio/TagsPage'

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Switch>
            <Route exact path="/" component={BuildPage} />
            <Redirect exact from="/build" to="/" />
            <Route exact path="/warmup" component={ToastPage} />
            <Redirect exact from="/toast" to="/warmup" />
            <Route exact path="/warmups" component={WarmupsPage} />
            <Route exact path="/approach" component={ApproachPage} />
            <Route exact path="/warmups/:slug" component={WarmupDetailPage} />
            <Route exact path="/login" component={LoginPage} />
            <Route exact path="/signup" component={SignupPage} />
            <ProtectedRoute exact path="/studio" component={StudioListPage} />
            <ProtectedRoute exact path="/studio/tags" component={TagsPage} />
            <ProtectedRoute exact path="/studio/warmups/new" component={WarmupEditorPage} />
            <ProtectedRoute exact path="/studio/warmups/:id" component={WarmupEditorPage} />
            <Redirect to="/" />
          </Switch>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  )
}
